import { useEffect } from 'react'
import { Col, Container, Row, ProgressBar } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { getOpinionComponentContent, getOpinions } from '../../actions/cms'
import { getPath } from '../../MultilingualRouter/MultilingualRouter'
import Pages from '../../Enum/Pages'
import OmmCarousel from '../Carousel/OmmCarousel'

const Opinions = () => {
  const dispatch = useDispatch()
  const content = useSelector((state) => state.cms.opinionComponent)
  const lang = useSelector((state) => state.lang.lang)
  const opinions = useSelector((state) => state.cms.opinions)
  const displayItem = 30

  useEffect(() => {
    dispatch(getOpinionComponentContent())
    dispatch(getOpinions(displayItem))
  }, [lang, dispatch])

  if (!opinions || !content) {
    return (
      <Container className="py-3">
        <ProgressBar striped animated now={100} />
      </Container>
    )
  }
  if (opinions.data?.length < 1) {
    return <div />
  }
  return (
    <Container className="pb-3">
      <Row className="align-items-center">
        <Col className="col-12 col-md-8">
          <div className="title title-with-icon mt-3">
            <i className="material-icons h1 mb-0 me-2 mt-2 text-primary align-middle">reviews</i>
            <div>
              <h2 className="mb-1 font-inherit">{content?.title}</h2>
              <h3 className="text-muted m-0 h5">
                <span className="text-primary">{opinions?.meta?.pagination?.total}</span> {content?.subTitle}
              </h3>
            </div>
          </div>
        </Col>
        <Col className="col-12 col-md-4 text-end mb-4 mb-md-0">
          <Link className="btn btn-sm btn-primary" to={getPath(Pages.feedbackPage)}>
            {content?.moreBtn}
          </Link>
        </Col>
      </Row>
      {opinions?.data?.length > 0 && (
        <OmmCarousel
          items={opinions?.data}
          itemsPerSlide={{ xs: 1, sm: 1, md: 2, lg: 3, xl: 3 }}
          type="review"
          slideClass="py-1 py-lg-3"
          itemClass="mb-3 mb-lg-4"
        />
      )}
    </Container>
  )
}

export default Opinions
